'use strict';

export default class Standard {
  constructor() {

    // Make external links open in a new tab
    const domainName = window.location.hostname;
    $('a[href^="http"]').each(function(){
      const href = this.href;
      if (href.indexOf(domainName) < 0) {
        this.setAttribute('target','_blank');
      }
    })

    // Add class to Contact us menu item
    $('.menu--main .menu-item').each(function() {
      const $menuItem = $(this);
      const $link = $menuItem.find('> a');
      if ($link.text().trim() === 'Contact us') {
        $menuItem.addClass('contact-us-link');
      }
    });
  }
}
